import styled from 'styled-components'

export const Loading = styled.div`
  color: #454ADE;
  font-size: 32px;
  margin: 15% 0;
  text-align: center;
`
